import { post as $post } from './core/fetch';


export const get_reports = (report_params) => $post('/report', report_params);
